import React, { createContext, useContext, useState, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';

// Create context
const ThemeContext = createContext();

// Custom hook to use theme context
export const useThemeContext = () => {
    return useContext(ThemeContext);
};

// ThemeProvider component
export const ThemeProvider = ({ children }) => {
    // Get initial theme from localStorage (if exists)
    const savedTheme = localStorage.getItem('darkMode') === 'true';
    const [darkMode, setDarkMode] = useState(savedTheme);

    useEffect(() => {
        localStorage.setItem('darkMode', darkMode); // Save the theme preference
    }, [darkMode]);

    const theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
        },
    });

    const toggleTheme = () => {
        setDarkMode((prev) => !prev);
    };

    return (
        <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
            <MuiThemeProvider theme={theme}>
                <CssBaseline /> 
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};
